import React from "react";
import { Badge as MantineBadge } from "@mantine/core";

const statusColors = {
  "Under Advert": "green",
  "Under vetting": "green",
  "Under CEO approval": "blue",
  "Under CFO approval": "blue",
  "Under HOD approval": "violet",
  "Under GM Approval": "pink",
  Rejected: "red",
};

const Badge = ({ status }) => {
  const color = statusColors[status] || "gray";
  return (
    <MantineBadge color={color} variant="light">
      {status}
    </MantineBadge>
  );
};

export default Badge;
